import { render } from "./BusinessruleValueForm.vue?vue&type=template&id=2f896ff7&ts=true"
import script from "./BusinessruleValueForm.vue?vue&type=script&lang=ts"
export * from "./BusinessruleValueForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QToggle});
